import { ComputedRef, Ref, ref, watch } from "vue"
import { ViewContext } from "concerns/useContextName"
import { groupMemberApi } from "store/api"

export function useIsOutsider(
  viewContext: Ref<ViewContext | null>,
  personalRecordId: ComputedRef<number>
) {
  const isOutsider = ref(false)

  watch(
    () => viewContext.value,
    async (viewContext: ViewContext) => {
      if (
        viewContext &&
        viewContext.group &&
        personalRecordId.value !== null &&
        personalRecordId.value !== undefined
      ) {
        const groupMemberships = await groupMemberApi
          .getGroupMember(personalRecordId.value.toString())
          .then((resp) => {
            return resp.data.group_memberships
          })
        if (groupMemberships === null || groupMemberships === undefined) {
          return
        }
        if (groupMemberships.length === 0) {
          isOutsider.value = true
          return
        }
        isOutsider.value = !groupMemberships.includes(viewContext.group.id)
      }
    },
    { immediate: true }
  )

  return isOutsider
}
